import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> Event Flyers: Workshops </h1>

    
    <div className="imgs max500">
        <div>
            <img src={require('../assets/graphicDesign/CIAJ/CIAJ1-01.png')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/graphicDesign/CIAJ/CIAJ2.png')} data-skip-gallery/>
        </div>
    </div>

    <br/>


    <p>The above flyers were created for <a href="https://djcherishtheluv.com/" target="_blank">DJ Cherish the Luv</a>'s "Cancer in a Jar" pediatric workshop, in which she 
    shares her therapeutic tactic of visualizing one's cancer outside of the body as an entity separate from oneself. 
    Participants create a physical manifestation of their cancer out of craft materials, and put in a jar to help them 
    identify and separate from their cancer.</p>

    

    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.